import React from 'react'
import { ScrollingTextContainer, ScrollText, Row } from '../../../../styles/Homepage/ScrollingTexts.style'

interface ScrollingTextProps {
    direction: 'left' | 'right';
    href: string;
    text: string;
}

const ScrollingText: React.FC<ScrollingTextProps> = ({ direction, href, text }) => {
    return (
        <ScrollingTextContainer>
            <Row>
                <ScrollText variant="h4" direction={direction}>
                    <a href={href} style={{ all: 'unset' }}>
                        {text}
                    </a>
                </ScrollText>
            </Row>
        </ScrollingTextContainer>
    )
}

export default ScrollingText
